import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { BasePresetUtil } from './base-preset-util';
import { ShadowPresetUtil } from './shadow-preset-util';
import { GlowPresetUtil } from './glow-preset-util';
import { ReflectionPresetUtil } from './reflection-preset-util';
import { SoftEdgePresetUtil } from './soft-edge-preset-util';

export class PresetUtilFactory {
    public static getPresetUtil(type: string): BasePresetUtil {
        switch (type) {
            case ActionType.SHADOW:
                return new ShadowPresetUtil();
            case ActionType.GLOW:
                return new GlowPresetUtil();
            case ActionType.REFLECTION:
                return new ReflectionPresetUtil();
            case ActionType.SOFTEDGE:
                return new SoftEdgePresetUtil();
            default:
                throw new Error(`Unsupported type: ${type}`);
        }
    }
}
